import { store } from '@betacrew/jars-flux'
export const componentKey = "FILING";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setHistory : (state, action) => {
            state.history = action.payload;
        },
        setStatusFilter : (state, action) => {
            state.statusFilter = action.payload;
        },
        setPayersList : (state, action) => {
            state.payersList = [...state.payersList, ...action.payload];
        },
        setSelectedPayer : (state, action) => {
            state.selectedPayer = action.payload;
        },
        setTotalHistory : (state, action) => {
            state.totalHistory = action.payload;
        },
        setRowsPerPage : (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSkip : (state, action) => {
            state.skip = action.payload;
        },
        setFilingStatuses : (state, action) => {
            state.filingStatuses = action.payload;
        },
        setLoadingState : (state, action) => {
            state.loadingState = action.payload;
        },
        setFormCategory: (state, action) => {
            state.formCategory = action.payload;
        },
    },
    initialReducerState: {
        statusFilter: [
            { key: "Submitted", label: "Submitted", value: "Submitted"},
            { key: "Approved", label: "Approvals", value: ""},
            { key: "Rejected", label: "Rejected/Resubmit", value: ""},
            { key: "AcceptedWErrors", label: "Accepted With Errors", value: ""},
            { key: "Payments", label: "Payments", value: ""},
            { key: "StateFile", label: "State Filing", value: ""},
            { key: "Reconciliation", label: "State Reconciliation", value: ""},
          ],
        filingStatuses: [],
        payersList: [{label: 'All Payers', value: 0}],
        selectedPayer: {label: 'All Payers', value: 0},
        history: [],
        totalHistory: 0,
        rowsPerPage: 10,
        skip: 0,
        loadingState: false,
        formCategory: [],
    }
});
export const { setHistory, setFormCategory, setSkip, setRowsPerPage, setLoadingState, setSelectedPayer, setPayersList, setStatusFilter, setTotalHistory, setFilingStatuses } = actions;